import { useEffect } from 'react';
import { useStore } from '../store';
import { CheckCircle, XCircle, Info, X } from 'lucide-react';
import clsx from 'clsx';

export default function Notifications() {
  const { notifications, removeNotification } = useStore();

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onRemove={() => removeNotification(notification.id)}
        />
      ))}
    </div>
  );
}

function NotificationItem({
  notification,
  onRemove,
}: {
  notification: { id: number; message: string; type: 'success' | 'error' | 'info' };
  onRemove: () => void;
}) {
  useEffect(() => {
    const timer = setTimeout(onRemove, 5000);
    return () => clearTimeout(timer);
  }, [onRemove]);

  const Icon = {
    success: CheckCircle,
    error: XCircle,
    info: Info,
  }[notification.type];

  return (
    <div
      className={clsx(
        'flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg min-w-[300px] max-w-md fade-in',
        {
          'bg-green-500 text-white': notification.type === 'success',
          'bg-red-500 text-white': notification.type === 'error',
          'bg-accent text-white': notification.type === 'info',
        }
      )}
    >
      <Icon size={20} />
      <span className="flex-1">{notification.message}</span>
      <button
        onClick={onRemove}
        className="hover:opacity-80 transition-opacity"
      >
        <X size={18} />
      </button>
    </div>
  );
}
